export default __webpack_public_path__ + "static/media/2010.60e9ece2.png";